import React, {useEffect, useMemo} from "react";
import {useForm} from "react-hook-form";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {AziendaEditorProps} from "../Azienda.generalita.page";
import FormButtons from "../../../components/FormButtons";
import {ComboBoxCdiCGruppi} from "../../../components/comboBox/ComboBoxCdiCGruppi";
import {useAziendaTabelle} from "../../PVA/PVAHooks";
import {AziendaBase} from "@commons/mapping/AziendaNavRecord";

const CdicGruppiEditor: React.FC<AziendaEditorProps> = ({defaultValues, resource, onSubmit, onCancel}) => {
    const {setValue, handleSubmit, reset, control, formState: {errors}} = useForm<AziendaRecord>();

    const initialValues: AziendaRecord = useMemo(() => {
        return {
            ...defaultValues, ...resource,
        };
    }, [resource, defaultValues]);


    useEffect(() => {
        reset(initialValues);
    }, [resource, reset]);

    const tabelle = useAziendaTabelle(resource.idAziendaMaster);
    const aziendaGruppi: (keyof AziendaBase)[] = [
        'codGruppo1', 'codGruppo2', 'codGruppo3',
        'codGruppo4', 'codGruppo5', 'codGruppo6',
        'codGruppo7', 'codGruppo8', 'codGruppo9',
        'codGruppo10', 'codGruppo11', 'codGruppo12'];

    return <>

        <form className="p-1" onSubmit={handleSubmit(onSubmit)}>

            <div className="flexRowWrapFull">
                <div className="sm1-3P !px-2">
                    <ComboBoxCdiCGruppi<AziendaRecord> label="Centro di costo" data={tabelle.dataCdiC} isLoading={tabelle.isLoadingCdiC} control={control}
                                                       name="codiceCDIC" defaultValue={defaultValues.codiceCDIC}/>
                </div>
            </div>

            <div className="flexRowWrapFull">
                {aziendaGruppi.map((gruppo, index) => {
                    return <div key={gruppo} className="mt-4 sm:basis-1/3 px-2">
                        <div className="">
                            <ComboBoxCdiCGruppi<AziendaRecord> label={tabelle.gruppi[index].descrizione} data={tabelle.gruppi[index].data} isLoading={tabelle.gruppi[index].isLoading}
                                                               control={control}
                                                               name={gruppo}
                                                               defaultValue={initialValues[gruppo]}/>
                        </div>
                    </div>
                })
                }
            </div>

            <FormButtons onCancel={onCancel} resource={resource}/>

        </form>

    </>
}
export default CdicGruppiEditor;
